class StudentsSelectedDisplay extends React.Component {
	constructor(props) {
		super();
		autobind(this);
	}

	render() {
		var students = $wr.sortByName(this.props.studentsSelected, "lastName");
		if (this.props.studentsSelected.length > 1) {
			var comma = ", "
		}
		if (this.props.studentsSelected.length == this.props.totalStudents) { 
			var studentsSelected = "All Students!"
		} else {
			var studentsSelected = students.map(function(student, i) {
				return (
					<span className="comma" ref="comma" key={ student.id }>
						{ student.display_name }
						{ i + 1 == this.props.studentsSelected.length ? "" : comma  }
					</span>
				)
			}.bind(this));
		}
		if (!this.props.hideTo) {
			var toSection = (<div className="toSection">To:</div>)
		}
		return (
			<div className="studentsSelectedSection">
				<div className="studentsSelected">
					{ toSection }
					<div className="listOfStudents">
						{ studentsSelected } <span className="spacer1" />
					</div>
				</div>		
			</div>
		)
	}
};

StudentsSelectedDisplay.propTypes = StrictPropTypes({
	studentsSelected: PropTypes.array,
	totalStudents: PropTypes.number,
	hideTo: PropTypes.bool
});

module.exports = StudentsSelectedDisplay;



// WEBPACK FOOTER //
// ./modules/components/org/roster/StudentsSelectedDisplay.js